import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Form, Popup, Input, Icon } from 'semantic-ui-react'
import CommentActions from 'Redux/CommentRedux'
import AuthActions from 'Redux/AuthRedux'
import CanvasActions from 'Redux/CanvasRedux'
import BrushSelector from './BrushSelector'
import styles from './CommentBoxStyles'

class CommentBox extends Component {
  static propTypes = {
    time: PropTypes.number,
    points: PropTypes.array
  }

  constructor (props) {
    super(props)
    this.state = {
      text: '',
      settingName: false,
      userName: props.userData.name
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.createData !== prevProps.createData) {
      this.setState({ text: '' })
      this.props.canvasSetActive(false)
      this.props.onPlayPause()
    }
    if (this.props.userData !== prevProps.userData) {
      this.setState({ userName: this.props.userData.name })
    }
  }

  onSave = () => {
    if (!this.state.text) { return }
    if (!this.state.userName) {
      this.setState({ settingName: true })
    } else {
        if (!this.props.userData.name && this.state.userName) {
          this.setState({ settingName: false })
          this.props.profileUpdateRequest({
            name: this.state.userName
          })
        }
        this.props.commentsCreateRequest({
          text: this.state.text,
          time: this.props.time,
          video_id: this.props.currentVideo.id
        })
    }
  }

  onTextChange = (_, { value }) => {
    this.setState({ text: value })
  }

  onUserNameChange = (_, { value }) => {
    this.setState({ userName: value })
  }

  onNameChange = e => {
    this.setState({ name: e.target.value })
  }

  onEmailChange = e => {
    this.setState({ email: e.target.value })
  }

  render () {
    return (
      <div className={styles.wrap}>
        <Form reply>
          <Form.TextArea
            rows={2}
            value={this.state.text}
            className={styles.textArea}
            placeholder='Write your comment here...'
            onChange={this.onTextChange}
            onClick={this.props.onStartTyping}
          />
          <div className={styles.btnWrap}>
            <BrushSelector />
            <Popup
              trigger={
                <Button
                  size='mini'
                  primary
                  onClick={this.onSave}
                  loading={this.props.fetching}
                  className={styles.submit}>
                    Submit
                </Button>
              }
              hoverable
              on='click'
              open={this.state.settingName}
            >
            <Form>
              <Form.Field style={{display: 'none'}}>
                <Form.Button
                  loading={this.props.userFetching}
                  onClick={this.onSave}>
                    Submit
                </Form.Button>
              </Form.Field>
              <Form.Field>
              <Input
                placeholder='Enter your full name...'
                onChange={this.onUserNameChange}
                icon={
                  <Icon
                    color='yellow'
                    name='save'
                    link
                    onClick={this.onSave}
                  />}
              />
              </Form.Field>
            </Form>
            </Popup>
          </div>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  currentVideo: state.videos.currentVideo,
  fetching: state.comments.createFetching,
  userFetching: state.auth.updateFetching,
  error: state.comments.createError,
  createData: state.comments.createData,
  isDrawing: state.canvas.isDrawing,
  userData: state.auth.userData
})

const mapDispatchToProps = (dispatch) => ({
  commentsCreateRequest: (params) =>
    dispatch(CommentActions.commentsCreateRequest(params)),
  canvasSetActive: (enabled) => dispatch(CanvasActions.canvasSetActive(enabled)),
  profileUpdateRequest: (params) =>
    dispatch(AuthActions.profileUpdateRequest(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CommentBox)



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/CommentBox/CommentBox.js